export default "__VITE_ASSET___q$p$jYy__"